import useGroupTexts from "@/common/hooks/useGroupTextx";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import MenuList from "./components/menuList";
import {
  CouponIcon,
  IconWrapper,
  MyCartIcon,
  MyOrdersIcon,
  RightArrow,
  StyledCartAlertBadge,
  StyledCouponAlertBadge,
  Title,
  TitleSection,
  WishlistIcon,
} from "./styled";
import { IMenu } from "./type";

export default function MyShoppingSection() {
  // const visibleMyCart = useVisibleMyCart();
  // const enableCoupon = useEnableCoupon();
  const visibleMyCart = true;
  const enableCoupon = true;
  const myShoppingTitleText = useGroupTexts("my_shopping_menu_title");
  const myShoppingOrdersText = useGroupTexts("my_shopping_orders_menu_title");
  const myShoppingWishlistText = useGroupTexts(
    "my_shopping_wishlist_menu_title",
  );
  const openFromProfile = value => {
    console.log(value);
  };

  const handleRedirectMyShopping = React.useCallback(() => {
    openFromProfile(false);
  }, []);

  const handleRedirectMyCart = React.useCallback(() => {
    openFromProfile(false);
  }, []);

  const handleRedirectCoupon = React.useCallback(() => {
    openFromProfile(false);
  }, []);

  const handleRedirectWishlist = React.useCallback(() => {
    openFromProfile(false);
  }, []);

  const menus = React.useMemo(() => {
    const elements: IMenu[] = [
      {
        key: "my-orders",
        label: myShoppingOrdersText?.singular,
        icon: (
          <IconWrapper>
            <MyOrdersIcon />
          </IconWrapper>
        ),
        handler: handleRedirectMyShopping,
      },
    ];

    if (visibleMyCart) {
      elements.push({
        key: "my-cart",
        label: <FormattedMessage id="menu_shopping_cart" />,
        icon: (
          <IconWrapper>
            <MyCartIcon />
            <StyledCartAlertBadge />
          </IconWrapper>
        ),
        handler: handleRedirectMyCart,
      });
    }
    if (enableCoupon) {
      elements.push({
        key: "coupon",
        label: <FormattedMessage id="profile_show_my_shopping_coupon" />,
        icon: (
          <IconWrapper>
            <CouponIcon />
            <StyledCouponAlertBadge />
          </IconWrapper>
        ),
        handler: handleRedirectCoupon,
      });
    }

    elements.push({
      key: "wishlist",
      label: myShoppingWishlistText?.singular,
      icon: (
        <IconWrapper>
          <WishlistIcon />
        </IconWrapper>
      ),
      handler: handleRedirectWishlist,
    });

    return elements;
  }, [
    visibleMyCart,
    myShoppingOrdersText,
    myShoppingWishlistText,
    enableCoupon,
    handleRedirectMyCart,
    handleRedirectMyShopping,
    handleRedirectWishlist,
  ]);

  return (
    <>
      <TitleSection onClick={handleRedirectMyShopping}>
        <Title>{myShoppingTitleText?.singular}</Title>
        <RightArrow />
      </TitleSection>
      {(visibleMyCart || enableCoupon) && <MenuList menus={menus} />}
    </>
  );
}
